import { today, tomorrow } from '@/utils/date'

export default defineNuxtRouteMiddleware(to => {
  if (to.path.includes('/dates/today')) {
    const todayDate = today().split('/')
    to.params.year = todayDate[0]
    to.params.month = todayDate[1]
    to.params.day = todayDate[2]
  } else if (to.path.includes('/dates/tomorrow')) {
    const tomorrowDate = tomorrow().split('/')
    to.params.year = tomorrowDate[0]
    to.params.month = tomorrowDate[1]
    to.params.day = tomorrowDate[2]
  }
})
